import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

export function useOperatorTabHistory(tabs: readonly string[], fallback = 'home') {
  const fromLocation = () => {
    const tab = globalThis.location.hash.slice(1);
    return tabs.includes(tab) ? tab : fallback;
  };
  const current = ref(fromLocation());
  const sync = () => {
    current.value = fromLocation();
  };
  onMounted(() => {
    globalThis.addEventListener('popstate', sync);
    globalThis.addEventListener('hashchange', sync);
  });
  onBeforeUnmount(() => {
    globalThis.removeEventListener('popstate', sync);
    globalThis.removeEventListener('hashchange', sync);
  });
  return computed({
    get: () => current.value,
    set: (tab: string) => {
      if (!tabs.includes(tab) || tab === current.value) return;
      const url = new URL(globalThis.location.href);
      url.hash = tab === fallback ? '' : tab;
      globalThis.history.pushState(globalThis.history.state, '', url);
      current.value = tab;
    },
  });
}
